<template>
    <div class="apprentice-simple-card">
        <h4 class="card-title">{{ $t('organization.users') }}</h4>

        <design-2021-apprentice-data-table
            :fields="fields"
            :items="users">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-user"
                    variant="primary"
                    @click="showCreateModal()">
                    {{ $t('organization.new_user') }}
                </b-button>
            </template>

            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-edit remove-icon-margin btn-edit-organization"
                        variant="primary-icon-only"
                        @click="onShow(data.item)"
                        :v-b-tooltip="$t('organization.edit_user')">
                    </b-button>

                    <b-button
                        class="btn-remove remove-icon-margin btn-remove-organization"
                        variant="danger-icon-only"
                        @click="onRemove(data.item.id)"
                        :v-b-tooltip="$t('organization.delete_user')">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-organization-settings-user-add-modal-component
            :organization-in="organizationIn"
            :users-in="users"
            ref="add-modal"
            @user-added="addUser($event)">
        </design-2021-organization-settings-user-add-modal-component>

        <design-2021-organization-settings-user-edit-modal-component
            :organization-in="organizationIn"
            :users-in="users"
            ref="edit-modal"
            @user-updated="updateUser($event)">
        </design-2021-organization-settings-user-edit-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-organization-settings-users-component',
    props: ['organizationIn'],
    data() {
        return {
            users: this.organizationIn.users,
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                    thClass: 'p-3',
                    tdClass: 'p-3',
                    sortable: true,
                },
                {
                    key: 'email',
                    label: 'Email',
                    thClass: 'p-3',
                    tdClass: 'p-3',
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                    thClass: 'p-3',
                    tdClass: 'p-3',
                },
            ],
            user_modal: false,
        };
    },
    methods: {
        onShow(user) {
            this.$refs['edit-modal'].show(user);
        },
        onRemove(id) {
            this.alert
                .confirm(
                    this.$t('organization.delete_user'),
                    this.$t('organization.are_you_sure_you_want_to_delete_this_user'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios.delete(this.routes.organizationUserDelete(id)).then(
                            (response) => {
                                this.alert.success();

                                this.users = this.users.filter(function (user) {
                                    return user.id !== id;
                                });
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        showCreateModal() {
            this.$refs['add-modal'].show();
        },
        addUser(user) {
            this.users.push(user);
        },
        updateUser(user) {
            this.users = this.users.map((u) => {
                if (u.id === user.id) {
                    return user;
                }
                return u;
            });
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    align-items: center;

    button:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}
</style>
